import { useCallback } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { ErrorScreen } from '@paysense-india-services/elevate-web'

import { DASHBOARD_API } from '@/constants/api'
import { ROUTES } from '@/constants/routes'

import { useFetch } from '@/hooks/useFetch'

import LoanDocumentsPanel from '@/components/LoanDocumentsPanel'
import PageContainer from '@/components/PageContainer'
import PageLoader from '@/components/PageLoader/index'

import PaymentStatusModal from '@/app/pages/dashboard/components/PaymentStatusModal'
import {
  PAYMENT_STATUS_CONFIG,
  PAYMENT_STATUS_QUERY_PARAMS
} from '@/app/pages/dashboard/components/PaymentStatusModal/constants'
import getDashboardComponent from '@/app/pages/dashboard/utils'

const DashboardPage = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  const paymentStatus = searchParams.get('status')
  const txnId = searchParams.get('txnId')
  const showPaymentStatusModal =
    !!paymentStatus && !!txnId && !!PAYMENT_STATUS_CONFIG[paymentStatus?.toLowerCase()]

  const clearPaymentStatusParams = useCallback(() => {
    const params = new URLSearchParams(searchParams)
    PAYMENT_STATUS_QUERY_PARAMS.forEach(param => params.delete(param))
    setSearchParams(params, { replace: true })
  }, [searchParams, setSearchParams])

  const handlePaymentStatusCta = useCallback(() => {
    const config = PAYMENT_STATUS_CONFIG[paymentStatus?.toLowerCase()]
    clearPaymentStatusParams()

    if (config?.retryPayment) {
      navigate(ROUTES.PAY)
    }
  }, [clearPaymentStatusParams, navigate, paymentStatus])

  const { data, loading, error, apiRequest } = useFetch(DASHBOARD_API, false, true)

  const paymentStatusModal = (
    <PaymentStatusModal
      onClose={clearPaymentStatusParams}
      onCtaClick={handlePaymentStatusCta}
      show={showPaymentStatusModal}
      status={paymentStatus}
    />
  )

  if (loading) {
    return (
      <>
        <PageLoader isLoading={loading} />
        {paymentStatusModal}
      </>
    )
  }

  if (error) {
    return (
      <>
        <ErrorScreen
          buttonText='Try again'
          description='Please try again or check back later. Maybe give your phone a nice slap? Hey, it works on the TV remote.'
          onButtonClick={apiRequest}
          title='Something went wrong'
        />
        {paymentStatusModal}
      </>
    )
  }

  const sectionItems = data?.sections?.items
  const hasSectionItems = Array.isArray(sectionItems) && sectionItems.length > 0

  return (
    <>
      {hasSectionItems ? (
        sectionItems.map(section => getDashboardComponent(section))
      ) : (
        <div className='appLayout'>
          <PageContainer className='ew-d-flex ew-flex-column'>
            <LoanDocumentsPanel />
          </PageContainer>
        </div>
      )}
      {paymentStatusModal}
    </>
  )
}

export default DashboardPage
